import React, { useEffect, useState } from 'react'
import Loading from '../Modals/Loading';
import { useNavigate } from 'react-router-dom';
import accountService from '../Services/accountService';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { FiEdit3 } from 'react-icons/fi';
import { HiOutlineTrash } from 'react-icons/hi';
import Head from '../Components/Head';

const Account = () => {

    const [trigger, setTrigger] = useState(false)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const getAccounts = async () => {
            try {
                setLoading(true)
                const response = await accountService.fetchAllaccounts()
                console.log("Fetched accounts:", response);
                setData(response.accounts)
                setLoading(false)
            }
            catch {

            }
        }
        getAccounts()
    }, [trigger])

    const handleStatusUpdate = async (id, value) => {
        await accountService.updateAccountStatus({ id: id, status: value === 'ACTIVE' ? 'DEACTIVE' : 'ACTIVE' }).then((res) => {
            setTrigger(!trigger)
        })

    }

    return (

        <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
            {
                loading ?
                    <div className="">
                        <Loading />
                    </div>
                    :
                    <div>
                        <div className=" flex flex-col">
                            <Head heading={"Accounts"} button_text={"Add Account"} navigation={() => navigate('/accounts/add')}/>
                            {data && data.length > 0 && (
                            <div className="table-div">
                                    <table>
                                    <thead>
                                        <tr className="border-y-2 text-left w-full text-black text-[10px]">
                                            <th className="rounded-tl-lg w-[2%] py-4 pl-4">
                                                 Name
                                            </th>
                                            <th className="w-[5%] py-4 ">
                                                 Title
                                            </th>
                                            <th className="w-[2%] py-4">
                                                Account Number
                                            </th>
                                            <th className="w-[2%] py-4 text-center">
                                                Current Balance
                                            </th>
                                            <th className="w-[1%] py-4 text-center">
                                                Ledger
                                            </th>
                                            <th className="w-[1%] py-4 text-center">
                                                Status
                                            </th>
                                            <th className="rounded-tr-lg w-[1%] py-4 text-center">
                                                Edit
                                            </th>
                                            <th className="rounded-tr-lg w-[1%] py-4 text-center">
                                                Delete
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((value, index) => (
                                            <tr key={index} className="bg-accent border-b border-gray-100 text-left">
                                                <td className="py-3 w-[2%] pl-4 font-bold">
                                                    {value.account_name}
                                                </td>
                                                <td className="py-3 w-[5%] font-semibold text-gray-800">
                                                    {value.account_title}
                                                </td>
                                                <td className="py-3 w-[1%]">
                                                    {value.account_number}
                                                </td>
                                                <td className="py-3 w-[2%] text-teal-600 font-bold text-center">
                                                    {value.current_balance}
                                                </td>
                                                <td className="py-3 w-[1%] text-center">
                                                    <button
                                                        className="text-primary"
                                                        onClick={() => navigate(`/accounts/accountLedger?id=${value.id}`)}
                                                        >
                                                        <IoDocumentTextOutline className="h-4 w-4 text-amber-500"/>
                                                    </button>
                                                   
                                                </td>
                                                <td className={`py-3 w-[1%] text-white`}>
                                                    <div className='flex justify-center'>
                                                        <div className={`${value.status === 'ACTIVE' ? 'bg-green-500 text-green-500' : 'bg-red-500 text-red-500'} bg-opacity-20 font-semibold py-1 px-2 rounded-md cursor-pointer`} onClick={() => handleStatusUpdate(value.id, value.status)}>
                                                            {value.status}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className={`py-3 w-[1%] text-white`}>
                                                    <div className="flex flex-row justify-center gap-3">
                                                        <button>
                                                            <FiEdit3 className="h-4 w-4 text-indigo-500"/>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className={`py-3 w-[1%] text-white`}>
                                                    <div className="flex flex-row justify-center gap-3">
                                                        <button>
                                                            <HiOutlineTrash className="h-4 w-4 text-red-500"/>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            )}
                        </div>
                    </div>
            }
        </div>
    )
}

export default Account
